import { TARGET_ELEMENT } from 'lib/trait';

export const targetElementTemplate = {
  type: TARGET_ELEMENT,
  config: {
    contentPreferredPosition: 'top',
    contentDistanceFromTarget: 20,
  },
};
